<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM8.16667 3.44983C8.16761 3.29821 8.13577 3.14818 8.07333 3.01C8.01387 2.87736 7.92951 2.75735 7.82483 2.6565C7.47835 2.33549 6.97663 2.24571 6.54033 2.42667C6.40033 2.4885 6.2755 2.569 6.16817 2.66817C6.06092 2.7668 5.97617 2.88736 5.91967 3.02167C5.86216 3.15706 5.83279 3.30273 5.83333 3.44983C5.83333 3.75667 5.94533 4.01917 6.16817 4.2385C6.39217 4.45783 6.66983 4.5675 7 4.5675C7.30594 4.56805 7.6007 4.45256 7.82483 4.24433C7.92951 4.14348 8.01387 4.02348 8.07333 3.89083C8.13593 3.7523 8.16777 3.60185 8.16667 3.44983ZM5.83333 11.6667H8.16667V5.83333H5.83333V11.6667Z"
      fill="currentColor"
    />
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class InfoIcon extends Vue {}
</script>
